import { AppBar, Box, Divider, Drawer, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Outlet, useNavigate } from 'react-router-dom';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import { orange } from '@mui/material/colors';

export const Admin = () => {
    // media query
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const user = localStorage.getItem('name');
    const userType = localStorage.getItem('user_type');
    const navigate = useNavigate();
    const [name,setName] = useState('')
    useEffect(()=>{
        //check if admin
        if(userType !== '1'){
            window.location.href = '/dashboard'
            // localStorage.removeItem('name','')
            // localStorage.removeItem('user_type','')
        }
        let n = localStorage.getItem('name');
        setName(n)
    },[])
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = () => {
        localStorage.setItem('name','');
        // navigate('/');
        window.location.href = '/'
    }
    // drawer
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };
    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250, height: '100%' }}
            role="presentation"
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <Divider />
            {/* <ThemeProvider theme={menuTheme}> */}
            <List>
                <ListItemButton button onClick={() => navigate('')}>
                    <ListItemIcon>
                        {/* <DashboardIcon sx={{ color: darkmodeRedux ? '#242526' : '#242526' }} /> */}
                    </ListItemIcon>
                    
                    <ListItemText primary={'Dashboard'} sx={{color:orange[800]}}/>
                </ListItemButton>
            </List>
            <Divider/>
            <List>
                <ListItemButton button onClick={() => navigate('/admin/quiz')}>
                    <ListItemIcon>
                        {/* <ContactPageIcon sx={{ color: darkmodeRedux ? '#242526' : '#242526' }} /> */}
                    </ListItemIcon>
                    <ListItemText primary={'Quiz'}/>
                </ListItemButton>
            </List><Divider/>
            <List>
                <ListItemButton button onClick={() => navigate('/admin/sample-quiz')}>
                    <ListItemIcon>
                        {/* <ContactPageIcon sx={{ color: darkmodeRedux ? '#242526' : '#242526' }} /> */}
                    </ListItemIcon>
                    <ListItemText primary={'Sample Quiz'}/>
                </ListItemButton>
            </List>
            <Divider/>
            <List>
                <ListItemButton button onClick={() => navigate('/admin/questions')}>
                    <ListItemIcon>
                        {/* <ContactPageIcon sx={{ color: darkmodeRedux ? '#242526' : '#242526' }} /> */}
                    </ListItemIcon>
                    <ListItemText primary={'Questions'}/>
                </ListItemButton>
            </List>
        {/* </ThemeProvider> */}
        </Box>
    )
    return (
        <>
        <Box>
        <AppBar position='fixed'>
            <Toolbar sx={{display:'flex',justifyContent:'space-between'}}>
                <Box>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                        onClick={toggleDrawer('left', true)}
                    >
                        <MenuIcon />
                    </IconButton>
                    
                    {/* <Typography>{name}</Typography> */}
                </Box>
                <div>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                >
                    <AccountCircle />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
                </div>
            </Toolbar>
        </AppBar>
        <Drawer
                anchor={'left'}
                open={state['left']}
                onClose={toggleDrawer('left', false)}
            >
                {list('left')}
        </Drawer>
            <Box sx={{ py: 1, marginTop: matches ? '64px' : '66px' }}>
                <Outlet />
            </Box>
        </Box>
        </>
        

    )
}
